import { useEffect, useState, useCallback } from 'react';
import AppHeader from '../../components/AppHeader';
import { auditApi } from '../../api';
import { ROLE_LABELS } from '../../contexts/MemberAuthContext';

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [actions, setActions] = useState([]);
  const [action, setAction] = useState('');
  const [limit, setLimit] = useState(200);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(() => {
    setLoading(true);
    const params = { limit };
    if (action) params.action = action;
    auditApi.list(params)
      .then((r) => setRows(r.data))
      .catch((err) => setError(err.response?.data?.error || 'Načtení selhalo.'))
      .finally(() => setLoading(false));
  }, [action, limit]);

  useEffect(() => { auditApi.actions().then((r) => setActions(r.data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const csvParams = { limit: 2000, ...(action ? { action } : {}) };

  return (
    <div>
      <AppHeader subtitle="Audit log" />
      <div className="container-wide" style={{ paddingTop: 24 }}>
        {error && <div className="alert alert-warning mb-16">{error}</div>}

        <div className="card mb-16">
          <div className="flex gap-8" style={{ flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <div className="form-group" style={{ marginBottom: 0, minWidth: 220 }}>
              <label>Typ akce</label>
              <select className="form-input" value={action} onChange={(e) => setAction(e.target.value)}>
                <option value="">Všechny akce</option>
                {actions.map((a) => <option key={a.action} value={a.action}>{a.label}</option>)}
              </select>
            </div>
            <div className="form-group" style={{ marginBottom: 0, width: 140 }}>
              <label>Počet záznamů</label>
              <select className="form-input" value={limit} onChange={(e) => setLimit(Number(e.target.value))}>
                <option value={100}>100</option>
                <option value={200}>200</option>
                <option value={500}>500</option>
                <option value={2000}>2000</option>
              </select>
            </div>
            <button className="btn btn-outline" onClick={load}>🔄 Obnovit</button>
            <a className="btn btn-primary" href={auditApi.csvUrl(csvParams)} download>⬇ Export CSV</a>
          </div>
        </div>

        {loading ? <div className="spinner" /> : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr><th>Čas</th><th>Akce</th><th>Kdo</th><th>Role</th><th>Detail</th><th>IP</th></tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id}>
                    <td className="text-muted" style={{ fontSize: '0.82rem', whiteSpace: 'nowrap' }}>
                      {new Date(r.timestamp).toLocaleString('cs-CZ')}
                    </td>
                    <td>{r.action_label}</td>
                    <td>{r.actor_name}</td>
                    <td className="text-muted" style={{ fontSize: '0.82rem' }}>{r.role ? (ROLE_LABELS[r.role] || r.role) : ''}</td>
                    <td className="text-muted" style={{ fontSize: '0.82rem' }}>{r.detail || ''}</td>
                    <td className="text-muted" style={{ fontSize: '0.8rem' }}>{r.ip || ''}</td>
                  </tr>
                ))}
                {rows.length === 0 && <tr><td colSpan={6} className="text-muted text-center">Žádné záznamy.</td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
